// extracted by mini-css-extract-plugin
export default {"divider":"Transfer_divider__102c6","buttonsWrapper":"Transfer_buttonsWrapper__8qNFL"};